import Upload from "../../../assets/icon/NewsIcons/MainAdmin/NewsUploadFile"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";


const MainAdminAddAdvertising = () => {

    // const [allValues, setAllValues] = useState({
    //             Title: data ? data.title : '',
    //             ImageUrl: data ? data.imageUrl : '',
      
        
    //         });
    //         const changeHandler = e => {
    //             if (e.target) {
                 
                   
        
        
    //                 setAllValues({ ...allValues, [e.target.name]: e.target.value })
    //             }
    //         }
    //          const editIndex = async () => {        
                    
                   
                  
                     
    //                     const dataUser = await axiosReq("Advertisement/UpdateAd", "put", {
    //                         AdvertisementId: data?.AdvertisementId,
    //                         Title: allValues?.Title,
    //                         ImageUrl: allValues?.ImageUrl,
                         
            
    //                     });
    //                     console.log(dataUser)
    //                     if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            

    //                         alert("موفقیت آمیز");
    //                     }
    //                     else {
    //                         alert("خطا");
    
    //                     }
                    
                   
    //             }


    return(
        <div className="py-[22px] px-[32px] shadow-search-shadow rounded-[10px]">
            <div className="mb-[24px]">
                <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[11px]">عنوان تبلیغ</p>
                <input className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-lightGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="عنوان تبلیغ اول" />
                <div class="flex items-center justify-center w-full  mt-[13px]">
    <label for="dropzone-file" class="flex flex-col items-center justify-center w-full h-[242px] border-[1px] border-lightGray border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
        <div class="flex flex-col items-center justify-center pt-5 pb-6">
            <Upload/>
            {/* <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Click to upload</span> or drag and drop</p>
            <p class="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG or GIF (MAX. 800x400px)</p> */}
            <p className="text-[12px] font-IRANYekanMedium text-lightGray mt-2">فایل را بارگزاری کنید</p>
        </div>
        <input id="dropzone-file" type="file" class="hidden" />
    </label>
                </div>
            </div>
            <div className="w-full flex justify-center">
            <button className="w-[80px] h-[40px]  rounded-[10px] flex justify-center items-center ">
                <p className="font-IRANYekanBold text-[15px] ">حذف</p>
            </button>
            <button className="w-[107px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] flex justify-center items-center ">
                <p className="font-IRANYekanBold text-[15px] text-white">بارگزاری</p>
            </button>
            </div>
        </div>
    )
}

export default MainAdminAddAdvertising;